/**
 * Shape 필터 헬퍼 — MetaEditPanel 이 "선택된 kind/relation 에 걸린 shape" 리스트를 뽑을 때 사용.
 *
 * Shape 는 (sourceKind, relation, targetKind) 트리플이므로 선택 맥락별로 다음 3가지 뷰가 필요하다:
 *
 * - outgoing  : kind 가 source 로 등장하는 shape  (→ targetKind 나열)
 * - incoming  : kind 가 target 으로 등장하는 shape  (sourceKind → 나열)
 * - relation  : relation 을 쓰는 모든 (source, target) 쌍
 *
 * 세 함수 모두 순수 필터라 `.test.ts` 로 Node env 에서 직접 검증한다.
 * 입력 순서를 유지하며 동일 객체 참조를 그대로 담는다 — 호출자가 React key 로 자연키를 쓰기 때문.
 */
import type { ShapeDef } from "../../api/admin-client.ts"

/** 해당 kind 가 source 로 등장하는 shape 만 반환. */
export function filterOutgoingShapes(
	shapes: ReadonlyArray<ShapeDef>,
	kindName: string
): ReadonlyArray<ShapeDef> {
	return shapes.filter((s) => s.sourceKind === kindName)
}

/** 해당 kind 가 target 으로 등장하는 shape 만 반환. */
export function filterIncomingShapes(
	shapes: ReadonlyArray<ShapeDef>,
	kindName: string
): ReadonlyArray<ShapeDef> {
	return shapes.filter((s) => s.targetKind === kindName)
}

/** 해당 relation 을 쓰는 shape 전체 반환 (sourceKind/targetKind 모두 포함). */
export function filterRelationShapes(
	shapes: ReadonlyArray<ShapeDef>,
	relationName: string
): ReadonlyArray<ShapeDef> {
	return shapes.filter((s) => s.relation === relationName)
}

/** shape 의 자연키 문자열 — React list key 용. `{source}|{relation}|{target}` */
export function shapeKey(shape: ShapeDef): string {
	return `${shape.sourceKind}|${shape.relation}|${shape.targetKind}`
}
